<template>
  <div class="container">
    <!-- 头部 -->
    <div class="top">
      <svg-icon class-name="svgs" icon-class="user" @click="$router.push({ name: 'User' })" />
      <div class="serach" @click="$router.push({ name: 'Market' })"><svg-icon class-name="svgs" icon-class="search" />{{
        $t('public').search }}</div>
      <svg-icon class-name="svgs" icon-class="service" @click="goServe" />
      <!-- <van-badge dot>
        <svg-icon class-name="svgs" icon-class="bell" @click="$router.push({ name: 'Notice' })" />
      </van-badge> -->
    </div>
    <!-- 轮播图 -->
    <!-- <div class="swipeInfo">
      <van-swipe :height="170" :autoplay="3000" indicator-color="var(--text_color)">
        <van-swipe-item v-for="(item, index) in bannerList" :key="`banli${index}`" @click="onBannerGo(item)">
          <img class="swipeimg" :src="baseUrl + item.image" />
        </van-swipe-item>
      </van-swipe>
    </div> -->
    <van-skeleton title :row="4" :loading="skeletonLoading">
      <!-- 登录 -->
      <div class="bannerInfo" v-if="banType == 1">
        <img class="bimg" src="@/assets/img/home_b1.png" />
        <div class="bbtxt">{{ $t('home').Welcomeback }}</div>
        <van-button block @click="$router.push({ name: 'Login' })">{{ $t('home').loginBtn }}</van-button>
      </div>
      <!-- 身份认证 -->
      <div class="bannerInfo" v-if="banType == 2">
        <img class="bimg" src="@/assets/img/home_b2.png" />
        <div class="bbtxt">{{ $t('home').CompleteAuth }}</div>
        <van-button block @click="$router.push({ name: 'Auth' })">{{ $t('home').authBtn }}</van-button>
      </div>
      <!-- 总资产 -->
      <div class="assetInfo" v-if="banType == 3">
        <div class="left">
          <div class="tit">
            <span>{{ $t('asset').Totalassetvaluation }}</span>
            <van-icon name="eye-o" color="var(--text_color)" size="18" v-if="isShow" @click="isShow = false" />
            <van-icon name="closed-eye" color="var(--text_color)" size="18" v-else @click="isShow = true" />
          </div>
          <div class="num" v-if="isShow">{{ propertyVo.totalAmount }}<span>USDT</span></div>
          <div class="num" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}<span>****</span></div>
          <div class="ynum" v-if="isShow">≈USD${{ propertyVo.totalAmount }}</div>
          <div class="ynum" v-else>{{ propertyVo.totalAmount.toString().replace(/./g, '*') }}</div>
        </div>
        <div class="rbtn" v-if="!$store.state.isSim" @click="$goRecharge('RechargeCurrency')">{{ $t('asset').Recharge }}</div>
      </div>
    </van-skeleton>
    <!-- 常用功能 -->
    <div class="commonInfo">
      <!-- 充币 -->
      <div class="item" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="recharge_currency" />
        <div class="txt">{{ $t('common').Depositcoins }}</div>
      </div>
      <!-- 法币入金 -->
      <!-- <div class="item" @click="$goRecharge('Recharge')" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="recharge" />
        <div class="txt">{{ $t('common').Rechargefiatcurrency }}</div>
      </div> -->
      <!-- 取款 -->
      <div class="item" @click="$router.push({ name: 'WithCurrency' })" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="with" />
        <div class="txt">{{ $t('common').Withdraw }}</div>
      </div>
      <!-- 闪兑 -->
      <div class="item" @click="$router.push({ name: 'AssetFlashcash' })">
        <svg-icon class-name="svgs" icon-class="flashcash" />
        <div class="txt">{{ $t('asset').flashcash }}</div>
      </div>
      <!-- C2C -->
      <div class="item" @click="$router.push({ name: 'C2c' })" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="c2c" />
        <div class="txt">C2C</div>
      </div>
      <!-- 理财 -->
      <div class="item" @click="$router.push({ name: 'Finance' })" v-if="!$store.state.isSim">
        <svg-icon class-name="svgs" icon-class="heel" />
        <div class="txt">{{ $t('common').documentation }}</div>
      </div>
      <!-- 客服 -->
      <div class="item" @click="goServe">
        <svg-icon class-name="svgs" icon-class="service" />
        <div class="txt">{{ $t('common').customer }}</div>
      </div>
      <!-- 更多功能 -->
      <div class="item" @click="$router.push({ name: 'Common' })">
        <svg-icon class-name="svgs" icon-class="common" />
        <div class="txt">{{ $t('home').more }}</div>
      </div>
    </div>
    <!-- 产品列表 -->
    <div class="productInfo">
      <!-- 分类 -->
      <!-- 行情分类 -->
      <div class="proTab"><span v-for="(item, index) in tabsMarket" :key="`tabma${index}`" :class="activeMarket == item.value ? 'active' : ''" @click="changeMarketTab(item.value)">{{ item.name
          }}</span></div>
      <!-- 产品标题 -->
      <div class="title">
        <div class="name">{{ $t('market').product }}</div><span>{{ $t('market').Latestprice }}</span><span>{{
          $t('market').volume }}</span><span>{{ $t('market').ChangeRatio }}</span>
      </div>
      <!-- 添加自选 -->
      <div class="addSelectBtn" v-if="activeMarket == 0 && showAddSelect">
        <van-button block @click="$router.push({ name: 'MySelect', query: { i: true } })">{{ $t('market').Addoptional
        }}</van-button>
      </div>
      <!-- 产品列表 -->
      <div class="item" v-for="(item, index) in pList" :key="`pro${index}`" @click="$router.push({ name: 'Kline', query: { id: item.productId } })">
        <div class="name"> <img :src="baseUrl + item.logoUrl" />{{ item.name }} </div>
        <span :class="item.priceChangeRatio > 0 ? 'green' : 'red'">{{ item.newPrice }}</span>
        <span>{{ item.volume | formatNumber }}</span>
        <span :class="item.priceChangeRatio > 0 ? 'greenbg' : 'redbg'" class="ratio">{{ item.priceChangeRatio }}%</span>
      </div>
      <!-- 查看更多 -->
      <div class="seemore" @click="$router.push({ name: 'Market' })">{{ $t('property').Seemore }}<van-icon name="arrow" size="12" color="var(--text_color)" />
      </div>
    </div>
    <!-- 公告 -->
    <!-- <div class="noticeInfo">
      <div class="ntit">{{ $t('common').Notice }}</div>
      <div class="item" v-for="(dItem, dIndex) in nList" :key="`notice${dIndex}`" @click="$router.push({ name: 'Detail', query: { Name: $t('common').Notice, id: dItem.contentLocalizationId } })">
        <img class="iiimg" v-if="dItem.image" :src="isHttp(dItem.image) ? dItem.image : baseUrl + dItem.image">
        <img class="iiimg" v-else src="@/assets/img/new_local.jpg">
        <div class="right">
          <div class="name">{{ dItem.localizationTitle }}</div>
          <div class="time">{{ dItem.occurrenceTime }}</div>
        </div>
      </div> -->
    <!-- 查看更多 -->
    <!-- <div class="seemore" @click="$router.push({ name: 'Notice' })">{{ $t('property').Seemore }}<van-icon name="arrow" size="12" color="var(--text_color)" />
      </div>
    </div> -->
    <!-- 取款选择 -->
    <van-popup v-model="showWithSelect" position="bottom" closeable>
      <div class="withSelInfo">
        <div class="tit">{{ $t('common').Withdraw }}</div>
        <div class="tabs" @click="$router.push({ name: 'WithCurrency' })">{{ $t('common').Cryptocurrencywithdrawal }}
          <span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span>
        </div>
        <div class="tabs" @click="$router.push({ name: 'With' })">{{ $t('common').Fiatmoneywithdrawal
        }}<span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span></div>
      </div>
    </van-popup>
    <!-- 充值选择 -->
    <van-popup v-model="showRechargeSelect" position="bottom" closeable>
      <div class="rechargeSelInfo">
        <div class="tit">{{ $t('asset').Recharge }}</div>
        <div class="tabs" @click="$goRecharge('RechargeCurrency')">{{ $t('asset').Cryptocurrencyrecharge }}
          <span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span>
        </div>
        <div class="tabs" @click="$goRecharge('Recharge')">{{ $t('asset').Fiatcurrencyrecharge
        }}<span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span></div>
      </div>
    </van-popup>
    <TabBar :active="'Home'" />
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import productApi from '@/api/product'
import TabBar from '@/components/tabBar'
import { webSocket } from "@/mixins/webSocket.js";
import { Token } from '@/utils/mm'
import onShowMixin from '@/mixins/onShow.js';
export default {
  mixins: [webSocket, onShowMixin],
  components: {
    TabBar
  },
  data() {
    return {
      skeletonLoading: true,
      showRechargeSelect: false,
      banType: 1,//1登录2认证3资产
      isShow: true,
      propertyVo: {},
      //行情分类
      activeMarket: 1,
      tabsMarket: [{
        name: this.$t('home').optional,
        value: 0
      }, {
        name: this.$t('home').HotList,
        value: 1
      }],
      showWithSelect: false,
      baseUrl: window.baseURL,
      showAddChat: false,
      pList: [],
      showAddSelect: false,
      bannerList: [],
      nList: []
    }
  },
  mounted() {
    this.getHomeHotList()
    // this.getContentList()
    this.getMemberInfo()
  },
  //销毁之前
  beforeDestroy() {
    this.websockClose();
  },
  methods: {
    isHttp(url) {
      return /^https?:\/\//.test(url)
    },
    onShow() {
      this.getMemberInfo()
    },
    // 获取用户信息
    async getMemberInfo() {
      if (!Token.get()) {
        this.banType = 1
        this.skeletonLoading = false
        this.clearCache() //未登录清理缓存
        return
      }
      const res = await userApi.getMemberInfo()
      if (res.user.authenticationStatus != '2' && res.user.authenticationStatus != '3' && res.user.authenticationStatus != '4')
        this.banType = 2
      else {
        this.banType = 3
        // 资产统计
        const ares = await userApi.getPropertyInfo({ type: 0 })
        this.propertyVo = ares.data
      }
      this.skeletonLoading = false
    },
    // 获取公告列表
    async getContentList() {
      const res = await systemApi.getContentList({
        pageNum: 1,
        pageSize: 3,
        type: '1'
      })
      this.nList = res.rows;
    },
    //切换行情分类
    changeMarketTab(val) {
      this.activeMarket = val
      if (val == 0) this.getOptionalProductList()
      if (val == 1) this.getHomeHotList()
    },
    // 获取轮播图
    async getBannerList() {
      const res = await systemApi.getBannerList()
      this.bannerList = res.bannerList
    },
    onBannerGo(val) {
      if (val.type == 1)
        this.$router.push({ path: val.path })
      else
        location.href = val.path
    },
    // 客服
    async goServe() {
      // const res = await systemApi.getConfig()
      // location.href = res.systemSetting.serviceUrl
      if (Token.get()) {
        const res = await userApi.getMemberInfo()
        const encodedData = JSON.stringify({ name: res.user.memberId, email: res.user.memberName });
        location.href = 'chatlinkonline.html?metadata=' + encodedData
      } else {
        location.href = 'chatlinkonline.html'
      }
    },
    // 查询自选产品列表
    async getOptionalProductList() {
      if (!Token.get()) {
        this.pList = []
        return
      }
      var parms = {}
      parms.pageNum = 1
      parms.pageSize = 1000
      parms.productBusiness = '1'
      const res = await productApi.getOptionalProductList(parms)
      this.pList = res.rows
      if (this.pList.length > 0)
        this.showAddSelect = false
      else this.showAddSelect = true
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    // 首页产品列表
    async getHomeHotList() {
      const res = await productApi.getHomeHotList()
      this.pList = res.rows
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    //推送
    websocketGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: that.pList.map(item => item.symbol)
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        // 产品列表
        that.pList.forEach((sItem) => {
          let quotes = reslult.find(item => item.Symbol == sItem.symbol);
          if (quotes) {
            sItem.newPrice = quotes.NewPrice
            sItem.volume = quotes.Volume
            sItem.priceChangeRatio = quotes.PriceChangeRatio
          }
        })
      })
    },
    // 清理缓存
    clearCache() {
      var lang = localStorage.getItem('language')
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.clearCache
      ) {
        // ✅ iOS WebView 环境
        window.webkit.messageHandlers.clearCache.postMessage(null);
      } else {
        // ✅ 浏览器环境执行本地清理
        localStorage.clear();
        sessionStorage.clear();
        document.cookie.split(";").forEach((c) => {
          const name = c.split("=")[0].trim();
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        });
        console.log("Web 缓存已清除（浏览器模式）");
      }
      // 设置默认语言
      if (lang) {
        localStorage.setItem('language', lang)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  font-size: 14px;
  padding-bottom: 75px;
  background: var(--background_color);

  .top {
    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    width: 100%;
    background: var(--background_color);
    z-index: 1000;

    .svgs {
      width: 22px;
      height: 22px;
      color: var(--text_color);
    }

    .serach {
      width: 260px;
      height: 30px;
      background: var(--info_color);
      display: flex;
      align-items: center;
      border-radius: 15px;
      color: var(--ntext_color);
      padding: 10px;
      font-size: 14px;

      .svgs {
        width: 18px;
        height: 18px;
        color: var(--ntext_color);
        margin-right: 5px;
      }
    }
  }

  .swipeInfo {
    padding: 60px 15px 0 15px;
    border-radius: 10px;

    .swipeimg {
      width: 100%;
      height: 170px;
    }
  }

  .bannerInfo {
    padding: 60px 15px 0 15px;

    .bimg {
      width: 100%;
      height: 120px;
    }

    .bbtxt {
      text-align: center;
      margin-top: 15px;
      font-size: 15px;
      font-weight: bold;
      color: var(--text_color);
    }

    .van-button {
      margin-top: 20px;
      background: var(--text_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 14px;
      font-weight: bold;
      color: var(--background_color);
    }
  }

  .assetInfo {
    padding: 80px 15px 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      width: 230px;

      .tit {
        display: flex;
        align-items: center;

        span {
          margin-right: 5px;
          font-size: 13px;
          color: var(--text_color);
        }
      }

      .num {
        margin-top: 10px;
        font-size: 25px;
        font-weight: 800;
        color: var(--text_color);

        span {
          font-weight: normal;
          margin-left: 5px;
          font-size: 13px;
        }
      }

      .ynum {
        margin-top: 10px;
        font-size: 12px;
        color: var(--ntext_color);
      }
    }

    .rbtn {
      width: 70px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: var(--background_color);
      background: var(--text_color);
      border-radius: 5px;
    }
  }

  .commonInfo {
    width: 100%;
    overflow-x: auto;
    padding: 30px 0;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    .item {
      display: inline-block;
      width: 22%;
      text-align: center;

      .svgs {
        width: 25px;
        height: 25px;
        color: var(--text_color);
      }

      .txt {
        margin-top: 10px;
        font-size: 12px;
        color: var(--text_color);
      }
    }
  }

  .commonInfo::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  .productInfo {
    padding: 0 15px;

    .proTab {
      font-size: 15px;
      font-weight: bold;
      color: var(--ntext_color);

      span {
        margin-right: 20px;
      }

      .active {
        color: var(--text_color);
      }
    }

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--ntext_color);
      font-size: 12px;
      height: 50px;

      .name {
        width: 30%;
        text-align: left;
      }

      span {
        width: 20%;
        text-align: right;
      }
    }

    .addSelectBtn {
      margin: 15px 0;

      .van-button {
        margin-top: 20px;
        background: var(--text_color);
        height: 40px;
        border-radius: 20px;
        border: 0;
        font-size: 14px;
        color: var(--background_color);
      }
    }

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      color: var(--text_color);
      font-size: 13px;

      .name {
        font-weight: bold;
        width: 30%;
        text-align: left;
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }

      span {
        width: 20%;
        text-align: right;
      }

      .ratio {
        width: 20%;
        padding: 5px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border-radius: 5px;
      }

      &:active {
        background: var(--info_color);
      }
    }

    .seemore {
      margin-top: 20px;
      text-align: center;
      font-size: 12px;
      color: var(--text_color);
    }
  }

  .noticeInfo {
    padding: 15px;

    .ntit {
      margin: 15px 0;
      font-size: 15px;
      font-weight: bold;
      color: var(--text_color);
    }

    .item {
      padding: 15px 0;
      border-bottom: 1px solid var(--info_color);
      display: flex;

      .iiimg {
        width: 120px;
        height: 70px;
        object-fit: cover;
        border-radius: 7px;
      }

      .right {
        margin-left: 10px;
        width: calc(100% - 130px);

        .name {
          font-size: 13px;
          font-weight: bold;
          color: var(--text_color);
          line-height: 20px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .time {
          margin-top: 15px;
          font-size: 12px;
          color: var(--ntext_color);
        }
      }
    }

    .seemore {
      margin: 30px 0;
      text-align: center;
      font-size: 12px;
      color: var(--text_color);
    }
  }

  .withSelInfo {
    padding: 20px;

    .tit {
      margin-bottom: 30px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
    }

    .tabs {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      color: var(--text_color);
      background: var(--info_color);
      border-radius: 10px;
      padding: 20px;
    }
  }

  .rechargeSelInfo {
    padding: 20px;

    .tit {
      margin-bottom: 30px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
    }

    .tabs {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      color: var(--text_color);
      background: var(--info_color);
      border-radius: 10px;
      padding: 20px;
    }
  }
}

::v-deep .van-dialog {
  background-color: transparent;
}

::v-deep .van-swipe {
  border-radius: 10px;
}

::v-deep .van-swipe__indicator {
  background-color: var(--ntext_color);
}

::v-deep .van-popup--bottom {
  border-radius: 10px 10px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 15px;
  color: var(--ntext_color);
}
</style>
